import { getRealDate } from '../utils';

export default function extendTaskInstanceModel(taskInstance) {
  const { dtstart, dtend } = taskInstance;
  return {
    ...taskInstance,
    dtstart: getRealDate(dtstart),
    dtend: getRealDate(dtend),
  };
}
